export const LocalStorage = {
  set(model, key = 'reservation') {
    localStorage.setItem(key, JSON.stringify(model));
  },
  get(key = 'reservation') {
    if (localStorage.getItem(key)) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch (e) {
        this.removeKey(key);
      }
    }
    return null;
  },
  removeKey(key) {
    localStorage.removeItem(key);
  },
};
